import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import errorBoundary from '@ifeng-fe/errorBoundary';
import styles from './index.css';
import { h5PageCount } from 'ThreeTerminal_utils';
import { callApp, getSchemeLink } from '@ifeng-fe/callapp';
import { WxLaunchApp } from 'ThreeTerminal_mobile_dynamic';

/**
 * 定义 CollectTitle 组件
 */
class AfterVideo extends PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    state = {
        durationState: '',
        isCloseVideo: false,
        isShowPlayIcon: true,
        isMuted: false,
        isOpenState: true,
    };

    beforeVideoRef = React.createRef();

    componentDidMount() {
        const { content = {} } = this.props;
        const { duration, beforeVideoChannel, classV = [] } = content;

        if (classV && classV.length > 0 && beforeVideoChannel) {
            let flage = true;
            const classVString = classV.join(',');

            beforeVideoChannel.split(',').forEach(item => {
                if (flage && classVString.includes(item)) {
                    this.setState({
                        isOpenState: true,
                    });
                    flage = false;
                }
            });

            if (flage || !navigator.userAgent.toLocaleLowerCase().includes('micromessenger')) {
                this.setState({
                    isOpenState: false,
                });
            }
        }

        this.videoEventHandle();
        this.setState({
            durationState: duration,
        });
    }

    videoEventHandle = () => {
        const { content = {} } = this.props;
        const { duration } = content;
        const beforeVideoDom = this.beforeVideoRef.current;

        beforeVideoDom.play();
        if (beforeVideoDom) {
            beforeVideoDom.addEventListener('timeupdate', () => {
                const durationNum = (duration && parseInt(duration)) || parseInt(beforeVideoDom.duration);
                const currentTime = parseInt(beforeVideoDom.currentTime);

                this.setState({
                    durationState: durationNum - currentTime,
                });
            });

            beforeVideoDom.addEventListener('ended', () => {
                this.closeVideoHandle();
            });

            beforeVideoDom.addEventListener('play', () => {
                this.setState({
                    isShowPlayIcon: false,
                });
            });
        }
    };

    playBeforeVideo = () => {
        this.beforeVideoRef.current.play();
    };

    closeVideoHandle = () => {
        this.setState({
            isCloseVideo: true,
        });
    };

    mutedHandle = value => {
        this.setState({
            isMuted: value,
        });
    };

    callAppHanle = (isSendCount = true, isJumpQQlink = false, isCallApp = true) => {
        const { content = {} } = this.props;
        const { beforeVideoScheme } = content;

        if (isSendCount) {
            h5PageCount([
                {
                    behavior: 'action',
                    type: 'frontvp',
                    other: {},
                },
            ]);
        }
        if (isCallApp) {
            callApp({
                docType: 'custom',
                pid: beforeVideoScheme,
                download: 'http://a.app.qq.com/o/simple.jsp?pkgname=com.ifeng.news2&ckey=CK1354725215087',
                downloadAd: 'https://statistics.appstore.ifeng.com/index.php/api/godownload?app_id=4&d_ch=7640',
                isCopySchemeUrl: isJumpQQlink,
            });
        }
    };

    render() {
        const { content = {} } = this.props;
        const { playUrl, postUrl, isOpen, wxLaunchType, isVideoShare, wxLaunchSwitch, beforeVideoScheme } = content;
        const { durationState, isShowPlayIcon, isMuted, isCloseVideo, isOpenState } = this.state;
        const schemeLink = getSchemeLink({
            docType: 'custom',
            pid: beforeVideoScheme,
        });

        return (
            isOpen &&
            isOpenState &&
            !isCloseVideo && (
                <div className={styles.beforeVideoBox}>
                    <div className={styles.beforeVideoBorder} onClick={this.callAppHanle}>
                        <video
                            className={styles.beforeVideo}
                            ref={this.beforeVideoRef}
                            src={playUrl}
                            controls={false}
                            muted={isMuted}
                            poster={postUrl}
                            x5-playsinline="true"
                            webkit-playsinline="true"
                            playsInline={true}
                            x5-video-player-type="h5"
                            airplay="auto"
                            onClick={this.callAppHanle}
                        />
                        <div className={styles.beforeVideoView} onClick={this.callAppHanle}>
                            查看详情
                        </div>
                        <div className={styles.beforeVideoShadow} />
                        {wxLaunchSwitch &&
                            !isVideoShare && (
                                <WxLaunchApp
                                    launchType={wxLaunchType}
                                    launchAppClick={this.callAppHanle.bind(this, true, false, false)}
                                    schemeLink={schemeLink}
                                    launchAppFail={this.callAppHanle.bind(this, false, true, true)}
                                />
                            )}
                    </div>
                    {isShowPlayIcon && <div className={styles.beforeVideoPlay} onClick={this.playBeforeVideo} />}
                    {!isMuted && (
                        <div
                            className={styles.beforeVideoVoice}
                            onClick={() => {
                                this.mutedHandle(true);
                            }}
                        />
                    )}
                    {isMuted && (
                        <div
                            className={styles.beforeVideoNoVoice}
                            onClick={() => {
                                this.mutedHandle(false);
                            }}
                        />
                    )}
                    {!isShowPlayIcon && (
                        <div
                            className={styles.beforeVideoTime}
                            onClick={() => {
                                this.closeVideoHandle();
                            }}>
                            跳过 <span className={styles.beforeVideoTimeNum}>{durationState}s</span>
                        </div>
                    )}
                </div>
            )
        );
    }
}

export default errorBoundary(AfterVideo);
